import { Box, styled, Typography } from "@mui/material";
import { StyledSelectField, StyledTextField } from "../commons/Containers";
import _ from "lodash";
import { InputFactory } from "./InputFactory";
import { ButtonsComponent } from "./ButtonsComponent";

const ComponentGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 4fr',
    alignItems: 'center',
    justifyContent: 'start',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(2),
}));

const headerFormat = [{ name: 'Text', value: 'text' }, { name: 'Image', value: 'image' }, { name: 'Video', value: 'video' }, { name: 'Document', value: 'document' }, { name: 'Location', value: 'location' }];

const HeaderComponent = ({ component, componentHandler, editing }) => {

    const HeaderInput = InputFactory[component.format];

    const getHeaderTextNamedParams = (component) => {
        return component.example?.header_text_named_params;
    };

    const addExample = (comp, list) => {
        if (_.isEmpty(comp.example)) {
            comp['example'] = {};
        }
        comp.example.header_text_named_params = list;
    };

    return (
        <ComponentGrid >
            <Typography variant="attribute" padding={1}>
                Content Type
            </Typography>
            <StyledSelectField editing={editing} options={headerFormat} value={component.format ? component.format : ''} valueHandler={(value) => componentHandler && componentHandler({ ...component, format: value })} />
            {HeaderInput && <HeaderInput editing={editing} component={component} componentHandler={componentHandler} getTextNamedParams={getHeaderTextNamedParams} addExample={addExample} />}
        </ComponentGrid >
    );

};

const BodyComponent = ({ component, componentHandler, editing }) => {

    const BodyInput = InputFactory['text'];

    const getBodyTextNamedParams = (component) => {
        return component.example?.body_text_named_params;
    };

    const addExample = (comp, list) => {
        if (_.isEmpty(comp.example)) {
            comp['example'] = {};
        }
        comp.example.body_text_named_params = list;
    };

    return (
        <ComponentGrid gap={1}>
            {BodyInput && <BodyInput editing={editing} component={component} componentHandler={componentHandler} getTextNamedParams={getBodyTextNamedParams} addExample={addExample} />}
        </ComponentGrid >
    );

};

const FooterComponent = ({ component, componentHandler, editing }) => {

    const getFooterText = (comp) => {
        const footer = comp.text;
        return footer ? footer : '';
    };

    return (
        <ComponentGrid gap={1}>
            <Typography variant="attribute">
                Content
            </Typography>
            <StyledTextField editing={editing} width="60ch" value={getFooterText(component)} valueHandler={(value) => componentHandler({ ...component, text: value })} />
        </ComponentGrid>
    );
};

export const ComponentFactory = {
    'header': HeaderComponent,
    'body': BodyComponent,
    'footer': FooterComponent,
    'buttons': ButtonsComponent,
};